module.exports = __webpack_public_path__ + "static/media/wall.7403a412.png";